module.exports = __webpack_public_path__ + "img/screen-share-mac.f3d1a71e.png";